import { render } from "./SubactivitiesGrade.vue?vue&type=template&id=64409652"
import script from "./SubactivitiesGrade.vue?vue&type=script&lang=js"
export * from "./SubactivitiesGrade.vue?vue&type=script&lang=js"

import "./SubactivitiesGrade.vue?vue&type=style&index=0&id=64409652&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__